<template>

    <div class="content">

        <h1>How To Evaluate Step-by-Step</h1>
        <p>This tutorial walks you through step-by-step how to do the evaluations quickly and accurately.</p>

        <div class="is-divider"></div>

        <h2>Overview</h2>
        <div>

            <p>Here are the high-level steps for evaluating a property for investment potential:</p>

            <ol>
                <li>
                    Enter the MLS number, or enter the property information if the property is not listed on the MLS.
                </li>
                <li>
                    Get the estimated sale price which is how much the property is worth assuming it's in good condition.
                </li>
                <li>
                    Get the estimated rent price which is how much rent you can charge.
                </li>
                <li>
                    Calculate the equity capture, cash flow, and percent returns on your investment.
                </li>
            </ol>

            <p>Let's get into the details for each step.</p>
        </div>

        <div class="is-divider"></div>

        <h2>1. Enter The MLS Number Or Property Information</h2>

        <p>Quest can evaluate properties listed on the MLS. It can also evaluate properties not listed on the MLS.</p>

        <p>If the property is listed on the MLS follow these steps to create the evaluation using the MLS:</p>

        <ol>
            <li>Click "New Property".</li>
            <li>Under the area "New Property (by MLS #)", select the MLS market.</li>
            <li>Enter the MLS number.</li>
            <li>Click "Create Property by MLS #".</li>
        </ol>

        <p>If the property is not listed on the MLS then enter the subject property information to get the evaluation started:</p>

        <ol>
            <li>Click "start new evaluation".</li>
            <li>Under the area "Enter subject property information" select the region.</li>
            <li>Enter the Street address (for example 2611 Suntree Ln).</li>
            <li>Enter the Subdivision (for example Cinco Ranch).</li>
            <li>Enter the Square Feet.</li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
        </ol>

    </div>

</template>

<script>
import Divider from "bulma-divider/dist/css/bulma-divider.min.css";

export default {
  components: {
    Divider
  }
};
</script>

<style>
</style>
